import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';

@Injectable({
  providedIn: 'root'
})
export class GusService extends BaseService {
  constructor(protected http: HttpClient) {
    super();
   }

   public loadGusData(nip) {
     return this.http.post<RequestResponse>(this.getUrl('getDataByNip'), nip);
   }
}
